import { useTranslation } from 'react-i18next';
import styles from '../styles/userLoading.module.scss';
import { LoadingIndicatorSpinnerBar } from '@abtasty/design-system';

export const CheckUserLoading = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <LoadingIndicatorSpinnerBar />
      <span>{t('Checking user login...')}</span>
    </div>
  );
};
